import { TOGGLE_SNUG_FIT } from "../actions/userSettings";

const initialState = {
    snugFit: true
};

export function UserSettingsState(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_SNUG_FIT:
            return {
                ...state,
                snugFit: !action.value
            };
        default:
            return state;
    }
}
